module.exports = __webpack_public_path__ + "static/media/Brownies & Blondies.e0655f63.jpg";